// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3gFiX","Back":"Button_Back__iIBB3","BorderCountries":"Button_BorderCountries__2MY2a"};